module.exports = __webpack_public_path__ + "static/media/discord_opposite.0a1d0be3.png";